module.exports = __webpack_public_path__ + "static/assets/900c51ce04ad85d6f41e64b212cf3e67.png";